export default {
  "pl": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Zmień logo (wymagany format PNG)"
      },
      "picture_logo_format": {
        "round": "Logo okrągłe",
        "square": "Logo kwadratowe"
      }
    }
  }
}
